import { StytchProvider as StytchProviderBase, useStytch as useStytchBase } from "@stytch/react";
import { createStytchHeadlessClient } from "@stytch/react/headless";
import { useCallback } from "react";
import { AuthenticateMethod } from "@medbillai/graphql-types";
import type { OAuthProviderType } from "@medbillai/ui";
import { analyticsService } from "../../lib/analytics/analytics";
export const StytchProvider = StytchProviderBase;
export const useStytch = useStytchBase;
export const StytchClient = createStytchHeadlessClient;

// Custom hook for web OAuth that uses redirects
export const useStartOAuth = (authRedirectUri: (method: AuthenticateMethod) => string) => {
  const stytch = useStytch();
  const startOAuth = useCallback(async (provider: OAuthProviderType) => {
    const redirectUrl = authRedirectUri(AuthenticateMethod.OAUTH);
    analyticsService.trackEvent("SubmitLogin", {
      method: "OAUTH"
    });
    if (provider === "APPLE") {
      await stytch.oauth.apple.start({
        login_redirect_url: redirectUrl,
        signup_redirect_url: redirectUrl
      });
    } else if (provider === "GOOGLE") {
      await stytch.oauth.google.start({
        login_redirect_url: redirectUrl,
        signup_redirect_url: redirectUrl
      });
    } else {
      throw new Error("Unsupported OAuth provider");
    }
  }, [stytch, authRedirectUri]);
  return {
    startOAuth
  };
};